import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
var _excluded = ["stateClass", "onClick", "content"];

/**
 * @module 日历组件，用于实现日面板、周面板和自定义面板
 */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
import { diffInMonth, isToday } from '@jd/jmtd-tools/es/date';
import ConfigConsumer from '../ConfigConsumer';
import { getLocale } from '../locale';
import { convertDyadicArray, getDateItemsByRange, getDayPanelDateRange, getWeekStart } from '../tools/date';
export var CalendarClasses = {
  td: 'jmtd-date-picker-cell jmtd-date-picker-date-cell',
  tdContent: 'jmtd-date-picker-cell-content',
  weekNumber: 'jmtd-date-picker-week-number-cell'
};

function Calendar(_ref) {
  var date = _ref.date,
      className = _ref.className,
      localeMap = _ref.localeMap,
      firstDayOfWeek = _ref.firstDayOfWeek,
      render = _ref.render,
      showWeekNumber = _ref.showWeekNumber,
      isDateDisabled = _ref.isDateDisabled,
      rowClassName = _ref.rowClassName;
  var dyadicArray = convertDyadicArray(getDateItemsByRange.apply(void 0, _toConsumableArray(getDayPanelDateRange(date, firstDayOfWeek))), 7);
  return /*#__PURE__*/React.createElement(ConfigConsumer, null, function (_ref2) {
    var locale = _ref2.locale;
    return /*#__PURE__*/React.createElement("div", {
      className: classNames('jmtd-date-picker-calendar', className)
    }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("thead", {
      className: "jmtd-date-picker-day-row"
    }, /*#__PURE__*/React.createElement("tr", null, showWeekNumber && /*#__PURE__*/React.createElement("td", {
      className: classNames(CalendarClasses.td, CalendarClasses.weekNumber)
    }), Array.from({
      length: 7
    }, function (_v, i) {
      return /*#__PURE__*/React.createElement("td", {
        key: i,
        className: CalendarClasses.td
      }, /*#__PURE__*/React.createElement("div", {
        className: CalendarClasses.tdContent
      }, (localeMap !== null && localeMap !== void 0 ? localeMap : getLocale(locale).datePicker.day)[(i + firstDayOfWeek) % 7]));
    }))), /*#__PURE__*/React.createElement("tbody", null, dyadicArray.map(function (dateItems) {
      var centerDate = dateItems[3];
      var yearOfFirstDay = centerDate.getFullYear();
      var weekNumber = Math.ceil(((centerDate - getWeekStart(yearOfFirstDay, 1, firstDayOfWeek)) / 86400000 + 1) / 7);
      var rowKey = JSON.stringify({
        date: date,
        weekNumber: weekNumber
      });
      var dateItemsInMonth = dateItems.filter(function (dateItem) {
        return diffInMonth(dateItem, date) === 0;
      });
      return /*#__PURE__*/React.createElement("tr", {
        key: weekNumber,
        className: classNames('jmtd-date-picker-week-row', rowClassName({
          dateItems: dateItems,
          rowKey: rowKey
        }))
      }, showWeekNumber && /*#__PURE__*/React.createElement("td", {
        className: classNames(CalendarClasses.td, CalendarClasses.weekNumber)
      }, weekNumber), dateItems.map(function (dateItem) {
        var disabled = isDateDisabled(dateItem, {
          centerDate: centerDate,
          weekNumber: weekNumber
        });
        var content = /*#__PURE__*/React.createElement("div", {
          className: CalendarClasses.tdContent
        }, /*#__PURE__*/React.createElement("span", {
          className: "jmtd-date-picker-cell-content-inner"
        }, dateItem.getDate()));

        var _render = render(dateItem, {
          dateItemsInMonth: dateItemsInMonth,
          dateItems: dateItems,
          centerDate: centerDate,
          weekNumber: weekNumber,
          content: content,
          disabled: disabled,
          rowKey: rowKey
        }),
            stateClass = _render.stateClass,
            _onClick = _render.onClick,
            wrappedContent = _render.content,
            others = _objectWithoutProperties(_render, _excluded);

        return /*#__PURE__*/React.createElement("td", _extends({
          key: dateItem.getTime(),
          role: "gridcell",
          className: classNames(CalendarClasses.td, {
            'jmtd-date-picker-cell-disabled': disabled,
            'jmtd-date-picker-cell-now': isToday(dateItem),
            // 是否是今日
            'jmtd-date-picker-date-cell-diff-month': diffInMonth(dateItem, date) !== 0 // 不是当前月

          }, stateClass),
          onClick: function onClick() {
            // 如果不禁用，点击时更新日期
            if (!disabled) {
              _onClick();
            }
          }
        }, others), wrappedContent || content);
      }));
    }))));
  });
}

Calendar.propTypes = {
  isDateDisabled: PropTypes.func,
  className: PropTypes.string,
  date: PropTypes.object.isRequired,
  firstDayOfWeek: PropTypes.number,
  showWeekNumber: PropTypes.bool,
  localeMap: PropTypes.array,
  render: PropTypes.func.isRequired,
  rowClassName: PropTypes.func
};
Calendar.defaultProps = {
  isDateDisabled: function isDateDisabled() {
    return false;
  },
  className: '',
  firstDayOfWeek: 1,
  showWeekNumber: false,
  localeMap: null,
  rowClassName: function rowClassName() {
    return {};
  }
};
export default Calendar;